import { LogoType } from '@wix/wix-emails-senders';
export const NEW_LOGO_IMAGE_SIZES = {
    small: 60,
    medium: 90,
    large: 122,
};
const classicLogoStyle = {
    backgroundColorEnabled: false,
    imageSize: 'small',
    textAlign: 'left',
    region: { paddingTop: '10px' },
};
export const WIX_BRAND_LOGO_STYLES = {
    [LogoType.wixClassic]: classicLogoStyle,
    [LogoType.wixStudio]: {
        backgroundColorEnabled: false,
        imageSize: 'small',
        textAlign: 'left',
        region: { paddingTop: '40px' },
    },
    [LogoType.wixPayments]: classicLogoStyle,
    [LogoType.wixVibe]: {
        backgroundColorEnabled: true,
        backgroundColor: '#EEF0FF',
        backgroundSize: 'box',
        imageSize: 'small',
        textAlign: 'center',
        region: {
            paddingTop: '60px',
            paddingBottom: '25px',
        },
    },
    [LogoType.marketplace]: {
        backgroundColorEnabled: false,
        imageSize: 'small',
        textAlign: 'left',
        region: {},
    },
    [LogoType.rise]: classicLogoStyle,
    [LogoType.wixel]: classicLogoStyle,
};
//# sourceMappingURL=logo-constants.js.map